/** Matches the worker's processRenderClip/processRenderV2 FPS and Remotion export. */
export const EXPORT_FPS = 30;
export const FRAME_DURATION = 1 / EXPORT_FPS;
export const snapToExportFrame = (seconds: number) => Math.round(seconds * EXPORT_FPS) / EXPORT_FPS;
export const lastCompleteFrameTime = (seconds: number) => Math.floor(seconds * EXPORT_FPS + 1e-7) / EXPORT_FPS;

/** Source timecode: minutes:seconds:frames (the final field is 00–29). */
export function formatFrameTime(seconds: number): string {
  const frame = Math.max(0, Math.round(seconds * EXPORT_FPS));
  return `${Math.floor(frame / (60 * EXPORT_FPS))}:${String(Math.floor(frame / EXPORT_FPS) % 60).padStart(2, '0')}:${String(frame % EXPORT_FPS).padStart(2, '0')}`;
}
